import { FilterInput } from '@/components/elements/filter-input/filter-input.component';
import { pretailoringPageMessages } from '../pre-tailoring.messages';

import { SearchInput } from '@/components/elements/search-input/search-input.component';
import { T } from '@/components/i18n/message.i18n.component';

export type QuestionFilter = 'ALL' | 'ANSWERED' | 'UNANSWERED';

const filterOptions = [
  { value: 'ALL', label: <T {...pretailoringPageMessages.questionFilterOptionAll} />, testId: 'filter-bar-option-all' },
  {
    value: 'ANSWERED',
    label: <T {...pretailoringPageMessages.questionFilterOptionAnswered} />,
    testId: 'filter-bar-option-answered',
  },
  {
    value: 'UNANSWERED',
    label: <T {...pretailoringPageMessages.questionsFilterOptionUnanswered} />,
    testId: 'filter-bar-option-unanswered',
  },
];

type Props = {
  search: string;
  filter: QuestionFilter;
  onFilterSearchChange: (search: string, filter: QuestionFilter) => void;
};

export const QuestionsHeading = ({ search, filter, onFilterSearchChange }: Props) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFilterSearchChange(e.target.value, filter);
  };

  const handleFilterChange = (value: string) => {
    onFilterSearchChange(search, value as QuestionFilter);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-between items-center mb-4">
        <h2 data-testid="pre-tailoring-questions-heading-title">
          <T {...pretailoringPageMessages.title} />
        </h2>
      </div>
      <div className="flex justify-between items-center mb-4">
        <SearchInput
          aria-label="Search questions"
          data-testid="pre-tailoring-questions-heading-search"
          placeholder="Search"
          onSearch={handleSearchChange}
        />
        <div className="flex flex-row items-center">
          <p className="mr-2 typo-secondary">
            <T {...pretailoringPageMessages.questionFilterLabel} />
          </p>
          <FilterInput
            aria-label="Filter questions"
            value={filter}
            options={filterOptions}
            data-testid="pre-tailoring-questions-heading-filter"
            onFilterChange={handleFilterChange}
          />
        </div>
      </div>
    </div>
  );
};
